export class AlertLineData {

	// Declaring data  from parent.
	private _alertPrimaryMessage: string = "";
	private _alertSecondaryMessage: string = "";
	private _alertSuccessMessage: string = "";
	public _alertDangerMessage: string = "";
	private _alertWarningMessage: string = "";
	private _alertInfoMessage: string = "";
	private _alertLightMessage: string = "";
	private _alertDarkMessage: string = "";

	constructor() {}

	get hasAlertPrimaryMessage(): boolean { return this._alertPrimaryMessage != ""; }
	get hasAlertSecondaryMessage(): boolean { return this._alertSecondaryMessage != ""; }
	get hasAlertSuccessMessage(): boolean { return this._alertSuccessMessage != ""; }
	get hasAlertDangerMessage(): boolean { return this._alertDangerMessage != ""; }
	get hasAlertWarningMessage(): boolean { return this._alertWarningMessage != ""; }
	get hasAlertInfoMessage(): boolean { return this._alertInfoMessage != ""; }
	get hasAlertLightMessage(): boolean { return this._alertLightMessage != ""; }
	get hasAlertDarkMessage(): boolean { return this._alertDarkMessage != ""; }

	get alertPrimaryMessage(): string { return this._alertPrimaryMessage; }
	get alertSecondaryMessage(): string { return this._alertSecondaryMessage; }
	get alertSuccessMessage(): string { return this._alertSuccessMessage; }
	get alertDangerMessage(): string { return this._alertDangerMessage; }
	get alertWarningMessage(): string { return this._alertWarningMessage; }
	get alertInfoMessage(): string { return this._alertInfoMessage; }
	get alertLightMessage(): string { return this._alertLightMessage; }
	get alertDarkMessage(): string { return this._alertDarkMessage; }

	set alertPrimaryMessage(msg: string) { this._alertPrimaryMessage = msg; }
	set alertSecondaryMessage(msg: string) { this._alertSecondaryMessage = msg; }
	set alertSuccessMessage(msg: string) { this._alertSuccessMessage = msg; }
	set alertDangerMessage(msg: string) { this._alertDangerMessage = msg; }
	set alertWarningMessage(msg: string) { this._alertWarningMessage = msg; }
	set alertInfoMessage(msg: string) { this._alertInfoMessage = msg; }
	set alertLightMessage(msg: string) { this._alertLightMessage = msg; }
	set alertDarkMessage(msg: string) { this._alertDarkMessage = msg; }

	public resetAlertPrimaryMessage() { this.alertPrimaryMessage = ""; }
	public resetAlertSecondaryMessage() { this.alertSecondaryMessage = ""; }
	public resetAlertSuccessMessage() { this.alertSuccessMessage = ""; }
	public resetAlertDangerMessage() { this.alertDangerMessage = ""; }
	public resetAlertWarningMessage() { this.alertWarningMessage = ""; }
	public resetAlertInfoMessage() { this.alertInfoMessage = ""; }
	public resetAlertLightMessage() { this.alertLightMessage = "";}
	public resetAlertDarkMessage() { this._alertDarkMessage = ""; }

	public resetAllMessages() {
		this._alertPrimaryMessage = "";
		this._alertSecondaryMessage = "";
		this._alertSuccessMessage = "";
		this._alertDangerMessage = "";
		this._alertWarningMessage = "";
		this._alertInfoMessage = "";
		this._alertLightMessage = "";
		this._alertDarkMessage = "";
	}
}
